import {CLRoute} from '../routing.types';

function isMatchRoute(route: CLRoute, path: string): boolean {
  const routeParts = route.split('?')[0].split('/').slice(1);
  const pathParts = path.split('/').slice(1);

  for (const [idx, part] of routeParts.entries()) {
    if (!pathParts[idx] || (!part.startsWith(':') && part !== pathParts[idx])) return false;
  }

  return true;
}

export default isMatchRoute;
